const getExtensions = (rootState) => rootState.ws.extensions || [];

export default getExtensions;
